import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import * as moment from 'moment'

import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { AddBillingDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/add-billing/add-billing-dialog.component'
import { ManageTagsDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/manage-tags-dialog/manage-tags-dialog.component'
import { ViewBillingDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/view-billing/view-billing-dialog.component'
import { UpdateQuoteDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/update-quote/update-quote-dialog.component'
import { UpdateInquiryDetailsDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/update-details/update-inquiry-details-dialog.component'
import { EditAdditionalGuestsComponent } from '@tv3/containers/inquiries/dialogs/shared/edit-additional-guests/edit-additional-guests.component'
import { EditGuestDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/edit-guest/edit-guest-dialog.component'
import { SidePanelService } from '@tv3/services/utils/side-panel.service'
import { AddInquiryDialogParams } from '@tv3/interfaces/dialogs/add-inquiry-dialog-params'
import { AddInquiryDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/add-inquiry/add-inquiry-dialog.component'
import { asLocalDate } from '@tokeet/tv3-platform'
import { PaymentGateway } from '@tokeet-frontend/gateways'
import { GetGuest } from '@tv3/store/guest/guest.actions'
import { Store } from '@ngrx/store'

@Injectable()
export class InquirySharedDialogsService {
  constructor(private dialog: MatDialog, private sidePanel: SidePanelService, private store: Store<any>) {}

  openAddBilling(inquiry: Inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        inquiry,
      },
    }

    return this.dialog.open(AddBillingDialogComponent, defaultConfig)
  }

  openTags(inquiry: Inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { inquiry },
    }

    return this.dialog.open(ManageTagsDialogComponent, defaultConfig)
  }

  openViewBilling(inquiry: Inquiry, payment: PaymentGateway) {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: '333px',
      panelClass: ['variable-modal'],
      data: {
        inquiry,
        payment,
      },
    }

    return this.dialog.open(ViewBillingDialogComponent, defaultConfig)
  }

  openUpdateQuote(inquiry: Inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '750px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        inquiry: inquiry,
      },
    }

    return this.dialog.open(UpdateQuoteDialogComponent, defaultConfig)
  }

  openUpdateDetails(inquiry: Inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        inquiry: inquiry,
      },
    }

    return this.dialog.open(UpdateInquiryDetailsDialogComponent, defaultConfig)
  }

  openEditAdditionalGuests(inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '800px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        inquiry,
      },
    }

    return this.dialog.open(EditAdditionalGuestsComponent, defaultConfig)
  }

  openEditGuest(inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        inquiry,
      },
    }

    return this.dialog.open(EditGuestDialogComponent, defaultConfig)
  }

  cloneInquiry(inquiry: Inquiry) {
    const startDate = asLocalDate(moment(new Date(inquiry.guestArrive * 1000)).unix())
    const endDate = asLocalDate(moment(new Date(inquiry.guestDepart * 1000)).unix())

    this.store.dispatch(GetGuest({ id: inquiry.guestId }))

    return this.openAddInquiry({
      title: inquiry.booked ? 'Clone Booking' : 'Clone Inquiry',
      start: startDate,
      end: endDate,
      isBooking: !!inquiry.booked,
      isClone: true,
      defaults: {
        arriveDate: startDate,
        departDate: endDate,
        rentalId: inquiry.rentalId,
        guestId: inquiry.guestId,
        adults: inquiry.numAdults,
        children: inquiry.numChild,
        source: inquiry.inquirySource,
      },
    })
  }

  openAddInquiry(params: AddInquiryDialogParams) {
    return this.sidePanel.openSide(AddInquiryDialogComponent, {
      data: params,
      panelClass: ['modal', 'modal-75', 'side-modal-lg', 'modal-edit-expense', 'right'],
    })
  }

  openCreateBooking(start?: number, end?: number, rentalId?: string) {
    const startDate = start && asLocalDate(moment(new Date(start * 1000)).unix())
    const endDate = end && asLocalDate(moment(new Date(end * 1000)).unix())

    return this.openAddInquiry({
      title: 'Create Booking',
      start: startDate,
      end: endDate,
      isBooking: true,
      defaults: {
        arriveDate: startDate,
        departDate: endDate,
        rentalId,
      },
    })
  }
}
